<template>
  <validation-provider
    ref="field"
    v-slot="{
      dirty,
      pristine,
      valid,
      invalid,
      pending,
      touched,
      untouched,
      errors,
      validate,
      passes,
      reset
    }"
    :mode="mode"
    :name="name"
    :vid="vid"
    :persist="persist"
    :rules="rules"
    :slim="true"
  >
    <div :class="{ 'form-input': true, 'form-input--error': errors.length }">
      <slot :errors="errors" :valid="valid" :invalid="invalid"></slot>
      <transition name="fade">
        <div v-if="show_errors && errors.length" :class="errors_class">
          {{ errors[0] }}
        </div>
      </transition>
    </div>
  </validation-provider>
</template>

<script>
  export default {
    props: {
      vid: {
        type: String,
        default: ''
      },

      rules: {
        type: Object,
        default: () => ({})
      },

      name: {
        type: String,
        default: undefined
      },

      /*
       * aggressive: this is the default behavior and it validates whenever an input event is emitted.
       * passive: doesn't validate on any event, so you can only validate manually.
       * lazy: validates on change or blur depending on the input type.
       * eager: hen the field is valid or has not yet been interacted with, it will validate on change. When the field becomes invalid due to the first validation, it will validate on input for as long the field is invalid. When the field is valid again, it will go back to validating on change. It is a mix between the aggressive and lazy modes
       * */
      mode: {
        type: String,
        default: 'eager'
      },

      persist: {
        type: Boolean,
        default: true
      },

      show_errors: {
        type: Boolean,
        default: true
      },

      errors_absolute: {
        type: Boolean,
        default: true
      }
    },

    computed: {
      errors_class() {
        return {
          'form-input__error': true,
          'form-input__error--absolute': this.errors_absolute
        };
      }
    },

    methods: {
      reset: function() {
        return this.$refs.field.reset();
      }
    }
  };
</script>

<style lang="scss">
  .form-input {
    position: relative;

    &--error {
      .ivu-input,
      .ivu-input-number,
      .ivu-select-selection,
      .vue-tel-input {
        border-color: $danger !important;
      }
    }

    &__error {
      font-size: 12px;
      color: $danger;
      margin-top: 0.25rem;

      &--absolute {
        position: absolute;
        z-index: 2;
        font-size: 10px;
      }
    }
  }
</style>
